// Formats a duration in seconds (as returned by the route endpoint) into a
// short human string — "12 min" or "1h 5m".
export function formatDuration(seconds) {
  if (!seconds) return "";
  const mins = Math.round(seconds / 60);
  if (mins < 60) return `${mins} min`;
  const hours = Math.floor(mins / 60);
  const remMins = mins % 60;
  return remMins > 0 ? `${hours}h ${remMins}m` : `${hours}h`;
}
